import { render, staticRenderFns } from "./ai-bot-landing.vue?vue&type=template&id=1b90cd46&scoped=true"
import script from "./ai-bot-landing.vue?vue&type=script&lang=js"
export * from "./ai-bot-landing.vue?vue&type=script&lang=js"
import style0 from "./ai-bot-landing.vue?vue&type=style&index=0&id=1b90cd46&prod&lang=less&scoped=true"
import style1 from "./ai-bot-landing.vue?vue&type=style&index=1&id=1b90cd46&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b90cd46",
  null
  
)

export default component.exports